/* eslint-disable react/jsx-no-literals */
import React from 'react'

function LinkedInMaintenaceIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="75"
      height="75"
      viewBox="0 0 75 75"
      {...props}
    >
      <defs>
        <clipPath id="clip-path">
          <rect
            id="Rectangle_38"
            data-name="Rectangle 38"
            width="75"
            height="75"
            transform="translate(0.188)"
            fill="none"
          />
        </clipPath>
      </defs>
      <g id="LinkedIn" transform="translate(-0.188)">
        <g id="Group_15" data-name="Group 15" clipPath="url(#clip-path)">
          <path
            id="Path_29"
            data-name="Path 29"
            d="M75.385,37.693A37.693,37.693,0,1,1,37.693,0,37.693,37.693,0,0,1,75.385,37.693"
            transform="translate(0 -0.001)"
            fill="#4467ad"
          />
          <path
            id="Path_30"
            data-name="Path 30"
            d="M154.589,132.393c.619-.7,1.129-1.4,1.765-2a9.686,9.686,0,0,1,6.966-2.749,16.132,16.132,0,0,1,4.38.533,8.561,8.561,0,0,1,6.079,6.394,26.782,26.782,0,0,1,.81,7.326c.009,5.207-.015,10.414,0,15.62,0,.487-.135.615-.616.611q-4.024-.033-8.047,0c-.472,0-.574-.142-.573-.588q.023-7.431,0-14.863a13.37,13.37,0,0,0-.431-3.69,4.149,4.149,0,0,0-4.563-3.234c-3.181.168-4.835,1.743-5.241,4.978a18.5,18.5,0,0,0-.142,2.324c0,4.819-.005,9.637.013,14.455,0,.48-.119.622-.61.618q-4.053-.036-8.106,0c-.433,0-.558-.114-.558-.552q.018-14.31,0-28.619c0-.472.154-.581.6-.578q3.848.029,7.7,0c.472,0,.594.149.584.6-.026,1.14-.009,2.281-.009,3.421"
            transform="translate(-113.98 -99.843)"
            fill="#fefefe"
          />
          <path
            id="Path_31"
            data-name="Path 31"
            d="M85.707,145.924c0,4.719-.008,9.439.011,14.158,0,.525-.128.683-.671.677-2.681-.03-5.363-.023-8.044,0-.43,0-.559-.1-.559-.549q.019-14.333,0-28.666c0-.4.1-.536.516-.534,2.72.017,5.441.023,8.161,0,.522-.005.594.2.592.646q-.02,7.137-.008,14.275"
            transform="translate(-59.795 -102.472)"
            fill="#fefefe"
          />
          <path
            id="Path_32"
            data-name="Path 32"
            d="M83.9,68.4a5.356,5.356,0,1,1-5.347-5.329A5.374,5.374,0,0,1,83.9,68.4"
            transform="translate(-57.246 -49.338)"
            fill="#fefefe"
          />
        </g>
      </g>
    </svg>
  )
}

export default LinkedInMaintenaceIcon
